"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_SORT_OPTIONS = exports.SITE_GROUP_OPTIONS = void 0;
exports.SITE_GROUP_OPTIONS = {
    cottages: 'COTTAGES',
    lodges: 'LODGES',
    'holiday-parks': 'PARKS',
    'novasol_cottages': 'NOVASOL_COTTAGES',
};
exports.SITE_SORT_OPTIONS = {
    BEST_MATCH: 'bestmatch',
    GRADE_DESC: 'gradedsc',
    PRICE_DESC: 'pricedsc',
    PRICE_ASC: 'priceasc',
};
//# sourceMappingURL=availability.types.js.map